import { render, staticRenderFns } from "./Propostas.vue?vue&type=template&id=ad4f99f6&scoped=true"
import script from "./Propostas.vue?vue&type=script&lang=js"
export * from "./Propostas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4f99f6",
  null
  
)

export default component.exports